import { combineReducers, Reducer } from "redux";
import config from "./drawerArea";
import { DrawerAreaState } from "./DrawerAreaState";

const areaReducer: Reducer<DrawerAreaState> = combineReducers({ config });
export * from "./actions";
export * from "./selectors";

export default areaReducer;
